import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import { CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import { Add, FilterAlt } from "@mui/icons-material";
import Table from "../../../components/Table";
import { useEffect, useState } from "react";
import { deleteData, fetchData } from "../../../services";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index.js";
import OperationCategoryFilterDialog from './components/OperationCategoryFilterDialog.js';

const OperationCategoryList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.operationCategoryStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.operationCategoryStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.operationCategoryStore?.totalPages);

    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        parentCategoryId: ""
    });
    const [operationCategoryData, setOperationCategoryData] = useState([]);

    useEffect(() => {
        fetchOperationCategoryList();
    },[isRefresh, currentPage, rowsPerPage, search])
    
    //List API
    const fetchOperationCategoryList = async () => {
        setCircleLoading(true);
        try {      
        let url = `/orchestration/key-value-category?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
                                    
        //filter
        if(filterData.isActive !== "") {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.parentCategoryId !== "") {
            url += `&parentCategoryId=${filterData.parentCategoryId}`;
        }
        const response = await fetchData(url);
        if(response?.success){
            setOperationCategoryData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Workflow List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Api List:', error);
            showSnackbar(error?.message, "error")
        }
        finally{
            setCircleLoading(false);
        }
    };
    
    //delete api function
    const handleDelete = async (row) => {
    try {
        const response = await deleteData(`/orchestration/key-value-category-delete`, {ids:[row?.id]});
        setIsRefresh(!isRefresh);
        if(response?.success){
            showSnackbar(response?.message, "success");
        }
        else{
            showSnackbar(response?.message, "error");
        }
    } catch (error) {
        console.error("Error deleting data:", error);
        showSnackbar(error?.response?.data?.message || "Error deleting data", "error");
    }
    };

    //table mapping
    const operationCategoryTable = {
        columns: [
            { key: "sno", label: "S.No.", renderCell: (row) => row.sno },            
            { key: "name", label: "Name", renderCell: (row) => row.categoryName },
            { key: "code", label: "Code", renderCell: (row) => row.code },
            { key: "createdAt", label: "Created At", renderCell: (row) => new Date(row.createdAt).toLocaleDateString("en-IN") },
            {
            key: "isActive",
            label: "Status",
            renderCell: (row) => (
                <span>
                {row.isActive ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                )}
                </span>
            )
            },
        ],
        rows: operationCategoryData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            categoryName: item?.categoryName || "",
            code: item?.code || "",
            createdAt: item?.createdAt || "",
            isActive: item?.isActive
        })),
    };

    const actions = {
        view: true,
        delete: true,

        onView: (row) => {
            navigate(`/operation/operation-category/operation-category-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };
  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Operation Category List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Operation Key Value Categories.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                    Filter
                    </MaterialButton>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => navigate('/operation/operation-category/operation-category-details')}
                    >
                        Opearation Category
                    </MaterialButton>
                </Stack>
            </Stack>
            )} 
        />
        <CardContent>
          <Table
          columns={operationCategoryTable?.columns}
          data={operationCategoryTable?.rows}
          actions={actions}
          pagination={{
              totalPages,
              currentPage,
              onPageChange: (page) => handlePaginationChange(page),
              rowsPerPage,
              onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
              rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Operation Category Data found"
          handleSearch={handleSearch}
          />
      </CardContent>
      <OperationCategoryFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchOperationCategoryList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default OperationCategoryList